import * as THREE from "three";
import Scene from "../../components/scene/Scene";
import { logger } from "@/utils/logger";

export class SceneManager {
  private static instance: SceneManager;

  private _renderer: THREE.WebGLRenderer | null = null;
  private _perspectiveCamera: THREE.PerspectiveCamera | null = null;
  private _screenshotCamera: THREE.PerspectiveCamera | null = null;
  private _scene: Scene | null = null;
  private _mount: HTMLElement | null = null;
  private _saoPass: any = null; // TODO: Replace with proper SAO pass type
  private _renderPass: any = null; // TODO: Replace with proper render pass type
  private _camera: THREE.PerspectiveCamera | null = null;

  private constructor() {
    // Private constructor for singleton pattern
  }

  static getInstance(): SceneManager {
    if (!SceneManager.instance) {
      SceneManager.instance = new SceneManager();
    }
    return SceneManager.instance;
  }

  // Getters and setters with proper typing
  get renderer(): THREE.WebGLRenderer | null {
    return this._renderer;
  }

  set renderer(renderer: THREE.WebGLRenderer | null) {
    this._renderer = renderer;
  }

  get scene(): Scene | null {
    return this._scene;
  }

  set scene(newScene: Scene | null) {
    if (this._scene && newScene && this._scene !== newScene) {
      if (typeof (this._scene as any).enablePasses === "function") {
        (this._scene as any).enablePasses((this._scene as any).passes, false);
      }
    }
    this._scene = newScene;
    if (
      this._scene &&
      typeof (this._scene as any).enablePasses === "function"
    ) {
      (this._scene as any).enablePasses((this._scene as any).passes, true);
    }
  }

  get perspectiveCamera(): THREE.PerspectiveCamera | null {
    return this._perspectiveCamera;
  }

  set perspectiveCamera(camera: THREE.PerspectiveCamera | null) {
    this._perspectiveCamera = camera;
  }

  get screenshotCamera(): THREE.PerspectiveCamera | null {
    return this._screenshotCamera;
  }

  set screenshotCamera(camera: THREE.PerspectiveCamera | null) {
    this._screenshotCamera = camera;
  }

  get mount(): HTMLElement | null {
    return this._mount;
  }

  set mount(mount: HTMLElement | null) {
    this._mount = mount;
    if (mount && this._renderer) {
      mount.appendChild(this._renderer.domElement);
    }
  }

  get saoPass(): any {
    return this._saoPass;
  }

  set saoPass(pass: any) {
    this._saoPass = pass;
  }

  get renderPass(): any {
    return this._renderPass;
  }

  set renderPass(pass: any) {
    this._renderPass = pass;
  }

  get camera(): THREE.PerspectiveCamera | null {
    return this._camera;
  }

  set camera(camera: THREE.PerspectiveCamera | null) {
    this._camera = camera;
  }
  // Update hook retained for future syncing if needed
  update(): void {
    // No-op by default. Keep method for API compatibility.
  }

  // Cleanup method
  dispose(): void {
    try {
      this._renderer = null;
      this._perspectiveCamera = null;
      this._screenshotCamera = null;
      this._scene = null;
      this._mount = null;
      this._saoPass = null;
      this._renderPass = null;
    } catch (error) {
      logger.error("Failed to dispose SceneManager", error, "SceneManager");
    }
  }
}
